import { UseCase } from './UseCase';
export class PlayerQuitUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return this.applicationServices.player.players()
            .then(players => {
            const player = players.find(player => player.username === event.username);
            return player ? this.onPlayer(player) : this.onMissingPlayer();
        });
    }
    onMissingPlayer() {
        return Promise.resolve();
    }
    onPlayer(player) {
        return this.applicationServices.player.removePlayer(player)
            .then(() => this.applicationServices.cleavage.hasCurrentCleavage())
            .then(hasCleavage => hasCleavage
            ? this.onCleavage(player)
            : this.quitBar(player))
            .catch(error => Promise.reject(error));
    }
    quitBar(player) {
        return this.applicationServices.bar.isPlayerInstalledOnTableStool(player.username)
            .then(isPlayerInstalledOnStool => isPlayerInstalledOnStool
            ? this.applicationServices.bar.removePlayerFromTableStool(player.username)
            : this.onPlayerMaybeInstalledOnBarStool(player))
            .catch(error => Promise.reject(error));
    }
    onPlayerMaybeInstalledOnBarStool(player) {
        return this.applicationServices.bar.isPlayerInstalledOnBarStool(player.username)
            .then(isPlayerInstalledOnBarStool => isPlayerInstalledOnBarStool
            ? this.applicationServices.bar.removePlayerFromBarStool(player.username)
            : Promise.resolve())
            .catch(error => Promise.reject(error));
    }
    onCleavage(player) {
        return this.applicationServices.cleavage.removePlayerOnCleavage(player)
            .then(() => this.applicationServices.cleavage.loadCurrentCleavage())
            .then(cleavage => this.applicationServices.interface.updateCleavage(cleavage))
            .then(() => this.quitBar(player))
            .catch(error => Promise.reject(error));
    }
}
